import {
  EndPointsNames,
  ApiCredentialsType,
  ErrorResponseCodeType,
} from '_core/types';
import { setEntityName } from '_core/util/object';

export const API_DOMAIN: EndPointsNames = 'ApiAccount';
export const ENDPOINT_API_PATH = 'v1/members/document/validate';
export const ENTITY_NAME = setEntityName(ENDPOINT_API_PATH);
const API_CREDENTIALS_TYPE: ApiCredentialsType =
  'TOKEN_AUTH_USER_OR_CREDENTIALS';
const URL_POSTMAN =
  'https://smiles-sa.postman.co/workspace/1aa3f7db-730f-4a9e-8904-3201cc3d9669/api/5a903615-d420-4e6c-9f80-80298b5cfe61?version=a90ce751-9714-4168-b499-5bb8426e9edd&tab=overview';

export const CODE_ERRORS: ErrorResponseCodeType[] = [
  {
    code: '1',
    message:
      'Ocorreu um erro técnico (Erro inesperado, favor contactar a Smiles)',
    bussinessErrorVariant: 'errorService',
  },
  {
    code: '4',
    message: 'Já existe um cadastro para este documento',
    bussinessErrorVariant: 'alreadyRegistrationDocument',
  },
];

export default {
  API_DOMAIN,
  ENDPOINT_API_PATH,
  API_CREDENTIALS_TYPE,
  URL_POSTMAN,
  CODE_ERRORS,
  ENTITY_NAME,
};
